import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import { applyThemeVariables } from './config/theme'
import App from './App.vue'
import router from './router'
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

applyThemeVariables()

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
})
app.mount('#app')

